export const model_po_visibility = () => {
  return {
    dispatch_summary: {
      Consignor: { value: "", type: "text" },
      Consignee: { value: "", type: "text", valid: true },
      ReferenceNo: { value: "", type: "text", valid: true },
      Destination: { value: "", type: "text", valid: true },
      Numberpackages: { value: "", type: "text", valid: true },
      DCNRelease: { value: "", type: "text", valid: true },
      Load: { value: "", type: "text", valid: true },
      Unloaded: { value: "", type: "text", valid: true },
      Finalized: { value: "", type: "text", valid: true },
      TotalWeight: { value: "", type: "text", valid: true },
      Totalvolume: { value: "", type: "text", valid: true },
    },
  };
};
